// Bundled with the app so the same official choices work without a network. No API imports.
export const morningAdhkar = [
  {
    id: 1,
    text: "اللّهُ لاَ إِلَـهَ إِلّا هُوَ الْحَيُّ الْقَيُّومُ لاَ تَأْخُذُهُ سِنَةٌ وَلاَ نَوْمٌ لَّهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الأَرْضِ مَن ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلاَ يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إلّا بِمَا شَاءَ وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالأَرْضَ وَلاَ يَؤُودُهُ حِفْظُهُمَا وَهُوَ الْعَلِيُّ الْعَظِيمُ.",
    repeat: 1,
    benefit: "آية الكرسي أعظم آية في القرآن الكريم. قال النبي ﷺ: «من قرأ آية الكرسي حين يصبح أُجيرَ من الجن حتى يمسي، ومن قالها حين يمسي أُجيرَ من الجن حتى يصبح».",
    name: "آية الكرسي"
  },
  {
    id: 2,
    text: "قُلْ هُوَ اللهُ أَحَدٌ، اللهُ الصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُن لَّهُ كُفُوًا أَحَدٌ.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قرأ قل هو الله أحد حين يصبح وحين يمسي ثلاث مرات كفتهُ من كل شيء».",
    name: "سورة الإخلاص"
  },
  {
    id: 3,
    text: "قُلْ أَعُوذُ بِرَبِّ الْفَلَقِ، مِن شَرِّ مَا خَلَقَ، وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ، وَمِن شَرِّالنَّفَّاثَاتِ فِي الْعُقَدِ، وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قرأ المعوذتين حين يصبح وحين يمسي ثلاث مرات كفتهُ من كل شيء».",
    name: "سورة الفلق"
  },
  {
    id: 4,
    text: "قُلْ أَعُوذُ بِرَبِّ النَّاسِ، مَلِكِ النَّاسِ، إِلَهِ النَّاسِ، مِن شَرِّ الْوَسْوَاسِ الْخَنَّاسِ، الَّذِي يُوَسْوِسُ فِي صُدُورِ النَّاسِ، مِنَ الْجِنَّةِ وَ النَّاسِ",
    repeat: 3,
    benefit: "المعوذات حرزٌ ووقاية بإذن الله من كل شر. قال النبي ﷺ: «تعوذوا بالمعوذات فما تعوذ متعوذ بمثلهن».",
    name: "سورة الناس"
  },
  {
    id: 5,
    text: "أَصْبَحْنا وَأَصْبَحَ المُـلْكُ لله وَالحَمدُ لله ، لا إلهَ إلاّ اللّهُ وَحدَهُ لا شَريكَ لهُ، لهُ المُـلكُ ولهُ الحَمْـد، وهُوَ على كلّ شَيءٍ قدير ، رَبِّ أسْـأَلُـكَ خَـيرَ ما في هـذا اليوم وَخَـيرَ ما بَعْـدَه ، وَأَعـوذُ بِكَ مِنْ شَـرِّ ما في هـذا اليوم وَشَرِّ ما بَعْـدَه، رَبِّ أَعـوذُ بِكَ مِنَ الْكَسَـلِ وَسـوءِ الْكِـبَر ، رَبِّ أَعـوذُ بِكَ مِنْ عَـذابٍ في النّـارِ وَعَـذابٍ في القَـبْر.",
    repeat: 1,
    benefit: "دعاء جامع في الصباح يتضمن الحمد والتوحيد وطلب خير اليوم والاستعاذة من شره، ومن الكسل وسوء الكبر وعذاب القبر والنار.",
    name: "دعاء الصباح"
  },
  {
    id: 6,
    text: "اللّهـمَّ أَنْتَ رَبِّـي لا إلهَ إلاّ أَنْتَ ، خَلَقْتَنـي وَأَنا عَبْـدُك ، وَأَنا عَلـى عَهْـدِكَ وَوَعْـدِكَ ما اسْتَـطَعْـت ، أَعـوذُ بِكَ مِنْ شَـرِّ ما صَنَـعْت ، أَبـوءُ لَـكَ بِنِعْـمَتِـكَ عَلَـيَّ وَأَبـوءُ بِذَنْـبي فَاغْفـِرْ لي فَإِنَّـهُ لا يَغْـفِرُ الذُّنـوبَ إِلاّ أَنْتَ .",
    repeat: 1,
    benefit: "سيد الاستغفار. قال النبي ﷺ: «من قالها من النهار موقناً بها فمات من يومه قبل أن يمسي فهو من أهل الجنة، ومن قالها من الليل وهو موقن بها فمات قبل أن يصبح فهو من أهل الجنة».",
    name: "سيد الاستغفار"
  },
  {
    id: 7,
    text: "رَضيـتُ بِاللهِ رَبَّـاً وَبِالإسْلامِ ديـناً وَبِمُحَـمَّدٍ صلى الله عليه وسلم نَبِيّـاً.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «ما من عبد يقول حين يصبح وحين يمسي: رضيتُ بالله رباً وبالإسلام ديناً وبمحمد نبياً إلا كان حقاً على الله أن يرضيه يوم القيامة».",
    name: "الرضا بالله رباً"
  },
  {
    id: 8,
    text: "اللّهُـمَّ إِنِّـي أُشْـهِدُك ، وَأُشْـهِدُ حَمَلَـةَ عَـرْشِـك ، وَمَلائكتَك ، وَجَمـيعَ خَلْـقِك ، أَنَّـكَ أَنْـتَ اللهُ لا إلهَ إلّا أَنْـتَ وَحْـدَكَ لا شَريكَ لَـك ، وَأَنَّ مُحَمّـداً عَبْـدُكَ وَرَسـولُـك.",
    repeat: 4,
    benefit: "قال النبي ﷺ: «من قال هذا الذكر أعتق الله ربعه من النار، فمن قالها مرتين أعتق نصفه، فمن قالها ثلاثاً أعتق ثلاثة أرباعه، فمن قالها أربعاً أعتقه الله من النار».",
    name: "الشهادة لله"
  },
  {
    id: 9,
    text: "اللّهُـمَّ ما أَصْبَـَحَ بي مِـنْ نِعْـمَةٍ أَو بِأَحَـدٍ مِـنْ خَلْـقِك ، فَمِـنْكَ وَحْـدَكَ لا شريكَ لَـك ، فَلَـكَ الْحَمْـدُ وَلَـكَ الشُّكْـر.",
    repeat: 1,
    benefit: "قال النبي ﷺ: «من قال هذا حين يصبح فقد أدّى شكر يومه».",
    name: "شكر نعمة الصباح"
  },
  {
    id: 10,
    text: "حَسْبِـيَ اللّهُ لا إلهَ إلّا هُوَ عَلَـيهِ تَوَكَّـلتُ وَهُوَ رَبُّ العَرْشِ العَظـيم.",
    repeat: 7,
    benefit: "قال النبي ﷺ: «من قال حين يصبح وحين يمسي: حسبي الله لا إله إلا هو عليه توكلت وهو رب العرش العظيم سبع مرات، كفاه الله ما أهمه».",
    name: "التوكل على الله"
  },
  {
    id: 11,
    text: "بِسـمِ اللهِ الذي لا يَضُـرُّ مَعَ اسمِـهِ شَيءٌ في الأرْضِ وَلا في السّمـاءِ وَهـوَ السّمـيعُ العَلـيم.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قال بسم الله الذي لا يضر مع اسمه شيء في الأرض ولا في السماء وهو السميع العليم ثلاث مرات لم تصبه فجأة بلاء».",
    name: "الحفظ باسم الله"
  },
  {
    id: 12,
    text: "اللّهُـمَّ بِكَ أَصْـبَحْنا وَبِكَ أَمْسَـينا ، وَبِكَ نَحْـيا وَبِكَ نَمُـوتُ وَإِلَـيْكَ النُّـشُور.",
    repeat: 1,
    benefit: "تفويض الأمر كله لله في الصباح والمساء، وإقرار بأن الحياة والموت بيده وحده سبحانه.",
    name: "التفويض إلى الله"
  },
  {
    id: 13,
    text: "أَصْبَحْـنا عَلَى فِطْرَةِ الإسْلاَمِ، وَعَلَى كَلِمَةِ الإِخْلاَصِ، وَعَلَى دِينِ نَبِيِّنَا مُحَمَّدٍ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ، وَعَلَى مِلَّةِ أَبِينَا إبْرَاهِيمَ حَنِيفاً مُسْلِماً وَمَا كَانَ مِنَ المُشْرِكِينَ.",
    repeat: 1,
    benefit: "التجديد للإيمان والثبات على الإسلام وملة إبراهيم الحنيفية في كل صباح.",
    name: "الاستقامة على الفطرة"
  },
  {
    id: 14,
    text: "سُبْحـانَ اللهِ وَبِحَمْـدِهِ عَدَدَ خَلْـقِه ، وَرِضـا نَفْسِـه ، وَزِنَـةَ عَـرْشِـه ، وَمِـدادَ كَلِمـاتِـه.",
    repeat: 3,
    benefit: "قالت جويرية رضي الله عنها: مررَ النبي ﷺ وقال لها هذا الذكر، ثم رجع بعد أن أشرقت الشمس وهي جالسة فقال: «ما زلتِ على الحال التي فارقتُك عليها؟» قالت: نعم. قال: «لقد قلتُ بعدك أربع كلمات ثلاث مرات لو وُزنت بما قلتِه منذ اليوم لوزنتهن».",
    name: "التسبيح الجامع"
  },
  {
    id: 15,
    text: "اللّهُـمَّ عافِـني في بَدَنـي ، اللّهُـمَّ عافِـني في سَمْـعي ، اللّهُـمَّ عافِـني في بَصَـري ، لا إلهَ إلاّ أَنْـتَ.",
    repeat: 3,
    benefit: "دعاء بالعافية في الجسد والسمع والبصر. كان أبو بكرة يدعو بهذا الدعاء في الصباح والمساء.",
    name: "طلب العافية"
  },
  {
    id: 16,
    text: "اللّهُـمَّ إِنّـي أَعـوذُ بِكَ مِنَ الْكُـفر ، وَالفَـقْر ، وَأَعـوذُ بِكَ مِنْ عَذابِ القَـبْر ، لا إلهَ إلّا أَنْـتَ.",
    repeat: 3,
    benefit: "الاستعاذة من الكفر والفقر وعذاب القبر، ثلاثة من أشد ما يخشاه المؤمن.",
    name: "الاستعاذة من الكفر والفقر"
  },
  {
    id: 17,
    text: "اللّهُـمَّ إِنِّي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في الدُّنْـيا وَالآخِـرَة ، اللّهُـمَّ إِنِّي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في ديني وَدُنْـيايَ وَأهْـلي وَمالـي ، اللّهُـمَّ اسْتُـرْ عـوْراتي وَآمِـنْ رَوْعاتـي ، اللّهُـمَّ احْفَظْـني مِن بَـينِ يَدَيَّ وَمِن خَلْفـي وَعَن يَمـيني وَعَن شِمـالي ، وَمِن فَوْقـي ، وَأَعـوذُ بِعَظَمَـتِكَ أَن أُغْـتالَ مِن تَحْتـي.",
    repeat: 1,
    benefit: "قال ابن عمر رضي الله عنهما: لم يكن النبي ﷺ يدع هؤلاء الكلمات حين يصبح وحين يمسي.",
    name: "طلب العفو والعافية"
  },
  {
    id: 18,
    text: "يا حَـيُّ يا قَيّـومُ بِـرَحْمَـتِكَ أَسْتَـغـيث ، أَصْلِـحْ لي شَـأْنـي كُلَّـه ، وَلا تَكِلـني إِلى نَفْـسي طَـرْفَةَ عَـين.",
    repeat: 3,
    benefit: "قال النبي ﷺ لفاطمة رضي الله عنها: «ما يمنعكِ أن تسمعي ما أوصيكِ به، أن تقولي إذا أصبحتِ وإذا أمسيتِ: يا حيُّ يا قيُّوم برحمتك أستغيث، أصلح لي شأني كله، ولا تكلني إلى نفسي طرفة عين».",
    name: "الاستغاثة بالحي القيوم"
  },
  {
    id: 19,
    text: "أَصْبَـحْـنا وَأَصبحَ المُـلكُ للهِ رَبِّ العـالَمـين ، اللّهُـمَّ إِنِّـي أسْـأَلُـكَ خَـيْرَ هـذا الـيَوْم ، فَـتْحَهُ ، وَنَصْـرَهُ ، وَنـورَهُ وَبَـرَكَتَـهُ ، وَهُـداهُ ، وَأَعـوذُ بِـكَ مِـنْ شَـرِّ ما فـيهِ وَشَـرِّ ما بَعْـدَه.",
    repeat: 1,
    benefit: "افتتاح اليوم بالإقرار بملك الله وسؤاله خير اليوم وفتحه ونصره وهداه.",
    name: "افتتاح اليوم"
  },
  {
    id: 20,
    text: "اللّهُـمَّ عالِـمَ الغَـيْبِ وَالشّـهادَةِ فاطِـرَ السّماواتِ وَالأرْضِ رَبَّ كـلِّ شَـيءٍ وَمَليـكَه ، أَشْهَـدُ أَنْ لا إِلـهَ إِلاّ أَنْت ، أَعـوذُ بِكَ مِن شَـرِّ نَفْسـي وَمِن شَـرِّ الشَّيْـطانِ وَشِـرْكِه ، وَأَنْ أَقْتَـرِفَ عَلـى نَفْسـي سوءاً أَوْ أَجُـرَّهُ إِلـى مُسْـلِم.",
    repeat: 1,
    benefit: "قال النبي ﷺ لأبي بكر الصديق رضي الله عنه: «قل إذا أصبحت وإذا أمسيت وإذا أخذت مضجعك» هذا الذكر.",
    name: "الاستعاذة من شر النفس"
  },
  {
    id: 21,
    text: "أَعـوذُ بِكَلِمـاتِ اللّهِ التّـامّـاتِ مِنْ شَـرِّ ما خَلَـق.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قال حين يمسي: أعوذ بكلمات الله التامات من شر ما خلق، لم تضره حُمَة تلك الليلة».",
    name: "الاستعاذة بكلمات الله"
  },
  {
    id: 22,
    text: "اللَّهُمَّ صَلِّ وَسَلِّمْ وَبَارِكْ على نَبِيِّنَا مُحمَّد.",
    repeat: 10,
    benefit: "قال النبي ﷺ: «من صلى عليَّ حين يصبح عشراً وحين يمسي عشراً أدركته شفاعتي يوم القيامة».",
    name: "الصلاة على النبي ﷺ"
  },
  {
    id: 23,
    text: "اللَّهُمَّ إِنَّا نَعُوذُ بِكَ مِنْ أَنْ نُشْرِكَ بِكَ شَيْئاً نَعْلَمُهُ ، وَنَسْتَغْفِرُكَ لِمَا لَا نَعْلَمُهُ.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قال ثلاث مرات: اللهم إنا نعوذ بك أن نشرك بك شيئاً نعلمه ونستغفرك لما لا نعلمه، ذهب عنه كل ما عمل من شرك».",
    name: "الاستعاذة من الشرك"
  },
  {
    id: 24,
    text: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ الْهَمِّ وَالْحَزَنِ، وَأَعُوذُ بِكَ مِنْ الْعَجْزِ وَالْكَسَلِ، وَأَعُوذُ بِكَ مِنْ الْجُبْنِ وَالْبُخْلِ، وَأَعُوذُ بِكَ مِنْ غَلَبَةِ الدَّيْنِ، وَقَهْرِ الرِّجَالِ.",
    repeat: 3,
    benefit: "دعاء جامع للاستعاذة من آفات النفس والبدن والمال.",
    name: "الاستعاذة من آفات النفس"
  },
  {
    id: 25,
    text: "أسْتَغْفِرُ اللهَ العَظِيمَ الَّذِي لاَ إلَهَ إلاَّ هُوَ، الحَيُّ القَيُّومُ، وَأتُوبُ إلَيهِ.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قال أستغفر الله العظيم الذي لا إله إلا هو الحي القيوم وأتوب إليه غُفر له وإن كان فرَّ من الزحف».",
    name: "الاستغفار"
  },
  {
    id: 26,
    text: "يَا رَبِّ , لَكَ الْحَمْدُ كَمَا يَنْبَغِي لِجَلَالِ وَجْهِكَ , وعظيم سُلْطَانِكَ.",
    repeat: 3,
    benefit: "ذكر جامع للحمد يُقرّ فيه العبد بعظمة الله وجلاله وسلطانه، مما يجلب الرضا والبركة.",
    name: "حمد الله على عظيم سلطانه"
  },
  {
    id: 27,
    text: "لا إله إلّا الله وَحْدَهُ لا شَريْكَ لهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءِ قَدِيرِ.",
    repeat: 10,
    benefit: "قال النبي ﷺ: «من قال هذا عشر مرات كانت له عدل عشر رقاب، وكُتب له مئة حسنة، ومُحيت عنه مئة سيئة، وكانت له حرزاً من الشيطان».",
    name: "التهليل"
  },
  {
    id: 28,
    text: "اللَّهُمَّ أَنْتَ رَبِّي لا إِلَهَ إِلا أَنْتَ ، عَلَيْكَ تَوَكَّلْتُ ، وَأَنْتَ رَبُّ الْعَرْشِ الْكَرِيمِ , مَا شَاءَ اللَّهُ كَانَ ، وَمَا لَمْ يَشَأْ لَمْ يَكُنْ ، وَلا حَوْلَ وَلا قُوَّةَ إِلا بِاللَّهِ الْعَلِيِّ الْعَظِيمِ , أَعْلَمُ أَنَّ اللَّهَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ ، وَأَنَّ الله قَدْ أَحَاطَ بِكُلِّ شَيْءٍ عِلْمًا , اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ شَرِّ نَفْسِي ، وَمِنْ شَرِّ كُلِّ دَابَّةٍ أَنْتَ آخِذٌ بِنَاصِيَتِهَا ، إِنَّ رَبِّي عَلَى صِرَاطٍ مُسْتَقِيمٍ.",
    repeat: 1,
    benefit: "ذكر جامع يتضمن التوكل على الله والإقرار بأنه رب العرش الكريم وأن ما شاء الله كان.",
    name: "التوكل الجامع"
  },
  {
    id: 30,
    text: "سبحان الله وبحمده",
    repeat: 100,
    benefit: "قال رسول الله ﷺ: «من قال حين يصبح وحين يمسي: سبحان الله وبحمده مائة مرة، لم يأت أحدٌ يوم القيامة بأفضل مما جاء به، إلا أحدٌ قال مثل ما قال أو زاد عليه».",
    name: "التسبيح"
  },
];

export const eveningAdhkar = [
  {
    id: 1,
    text: "اللّهُ لاَ إِلَـهَ إِلّا هُوَ الْحَيُّ الْقَيُّومُ لاَ تَأْخُذُهُ سِنَةٌ وَلاَ نَوْمٌ لَّهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الأَرْضِ مَن ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلاَ يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إلّا بِمَا شَاءَ وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالأَرْضَ وَلاَ يَؤُودُهُ حِفْظُهُمَا وَهُوَ الْعَلِيُّ الْعَظِيمُ.",
    repeat: 1,
    benefit: "قال النبي ﷺ: «من قرأ آية الكرسي حين يصبح أُجيرَ من الجن حتى يمسي، ومن قالها حين يمسي أُجيرَ من الجن حتى يصبح».",
    name: "آية الكرسي"
  },
  {
    id: 2,
    text: "آمَنَ الرَّسُولُ بِمَا أُنْزِلَ إِلَيْهِ مِنْ رَبِّهِ وَالْمُؤْمِنُونَ ۚ كُلٌّ آمَنَ بِاللَّهِ وَمَلَائِكَتِهِ وَكُتُبِهِ وَرُسُلِهِ لَا نُفَرِّقُ بَيْنَ أَحَدٍ مِنْ رُسُلِهِ ۚ وَقَالُوا سَمِعْنَا وَأَطَعْنَا ۖ غُفْرَانَكَ رَبَّنَا وَإِلَيْكَ الْمَصِيرُ. لَا يُكَلِّفُ اللَّهُ نَفْسًا إِلَّا وُسْعَهَا لَهَا مَا كَسَبَتْ وَعَلَيْهَا مَا اكْتَسَبَتْ رَبَّنَا لَا تُؤَاخِذْنَا إِنْ نَسِينَا أَوْ أَخْطَأْنَا رَبَّنَا وَلَا تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَى الَّذِينَ مِنْ قَبْلِنَا رَبَّنَا وَلَا تُحَمِّلْنَا مَا لَا طَاقَةَ لَنَا بِهِ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا وَارْحَمْنَا أَنْتَ مَوْلَانَا فَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ.",
    repeat: 1,
    benefit: "قال النبي ﷺ: «من قرأ الآيتين من آخر سورة البقرة في ليلة كفتاه».",
    name: "خاتمة سورة البقرة"
  },
  {
    id: 3,
    text: "قُلْ هُوَ اللهُ أَحَدٌ، اللهُ الصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُن لَّهُ كُفُوًا أَحَدٌ.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قرأ قل هو الله أحد حين يصبح وحين يمسي ثلاث مرات كفتهُ من كل شيء».",
    name: "سورة الإخلاص"
  },
  {
    id: 4,
    text: "قُلْ أَعُوذُ بِرَبِّ الْفَلَقِ، مِن شَرِّ مَا خَلَقَ، وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ، وَمِن شَرِّالنَّفَّاثَاتِ فِي الْعُقَدِ، وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قرأ المعوذتين حين يصبح وحين يمسي ثلاث مرات كفتهُ من كل شيء».",
    name: "سورة الفلق"
  },
  {
    id: 5,
    text: "قُلْ أَعُوذُ بِرَبِّ النَّاسِ، مَلِكِ النَّاسِ، إِلَهِ النَّاسِ، مِن شَرِّ الْوَسْوَاسِ الْخَنَّاسِ، الَّذِي يُوَسْوِسُ فِي صُدُورِ النَّاسِ، مِنَ الْجِنَّةِ وَ النَّاسِ",
    repeat: 3,
    benefit: "المعوذات حرزٌ ووقاية بإذن الله من كل شر.",
    name: "سورة الناس"
  },
  {
    id: 6,
    text: "أَمْسَيْـنا وَأَمْسـى المـلكُ لله وَالحَمدُ لله ، لا إلهَ إلاّ اللّهُ وَحدَهُ لا شَريكَ لهُ، لهُ المُـلكُ ولهُ الحَمْدُ وَهُوَ على كلّ شَيءٍ قدير ، رَبِّ أسْـأَلُـكَ خَـيرَ ما في هـذهِ اللَّـيْلَةِ وَخَـيرَ ما بَعْـدَهـا ، وَأَعـوذُ بِكَ مِنْ شَـرِّ ما في هـذهِ اللَّـيْلةِ وَشَرِّ ما بَعْـدَهـا ، رَبِّ أَعـوذُبِكَ مِنَ الْكَسَـلِ وَسـوءِ الْكِـبَر ، رَبِّ أَعـوذُبِكَ مِنْ عَـذابٍ في النّـارِ وَعَـذابٍ في القَـبْر.",
    repeat: 1,
    benefit: "دعاء جامع في المساء يتضمن الحمد والتوحيد وطلب خير الليلة والاستعاذة من شرها.",
    name: "دعاء المساء"
  },
  {
    id: 7,
    text: "اللّهـمَّ أَنْتَ رَبِّـي لا إلهَ إلاّ أَنْتَ ، خَلَقْتَنـي وَأَنا عَبْـدُك ، وَأَنا عَلـى عَهْـدِكَ وَوَعْـدِكَ ما اسْتَـطَعْـت ، أَعـوذُ بِكَ مِنْ شَـرِّ ما صَنَـعْت ، أَبـوءُ لَـكَ بِنِعْـمَتِـكَ عَلَـيَّ وَأَبـوءُ بِذَنْـبي فَاغْفـِرْ لي فَإِنَّـهُ لا يَغْـفِرُ الذُّنـوبَ إِلاّ أَنْتَ .",
    repeat: 1,
    benefit: "سيد الاستغفار. قال النبي ﷺ: «من قالها من الليل وهو موقن بها فمات قبل أن يصبح فهو من أهل الجنة».",
    name: "سيد الاستغفار"
  },
  {
    id: 8,
    text: "رَضيـتُ بِاللهِ رَبَّـاً وَبِالإسْلامِ ديـناً وَبِمُحَـمَّدٍ صلى الله عليه وسلم نَبِيّـاً.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «ما من عبد يقول حين يصبح وحين يمسي: رضيتُ بالله رباً وبالإسلام ديناً وبمحمد نبياً إلا كان حقاً على الله أن يرضيه يوم القيامة».",
    name: "الرضا بالله رباً"
  },
  {
    id: 9,
    text: "اللّهُـمَّ إِنِّـي أُشْـهِدُك ، وَأُشْـهِدُ حَمَلَـةَ عَـرْشِـك ، وَمَلائكتَك ، وَجَمـيعَ خَلْـقِك ، أَنَّـكَ أَنْـتَ اللهُ لا إلهَ إلّا أَنْـتَ وَحْـدَكَ لا شَريكَ لَـك ، وَأَنَّ مُحَمّـداً عَبْـدُكَ وَرَسـولُـك.",
    repeat: 4,
    benefit: "قال النبي ﷺ: «من قال هذا الذكر أربعاً أعتقه الله من النار».",
    name: "الشهادة لله"
  },
  {
    id: 10,
    text: "اللّهُـمَّ ما أَمسى بي مِـنْ نِعْـمَةٍ أَو بِأَحَـدٍ مِـنْ خَلْـقِك ، فَمِـنْكَ وَحْـدَكَ لا شريكَ لَـك ، فَلَـكَ الْحَمْـدُ وَلَـكَ الشُّكْـر.",
    repeat: 1,
    benefit: "قال النبي ﷺ: «من قال هذا حين يمسي فقد أدّى شكر ليلته».",
    name: "شكر نعمة المساء"
  },
  {
    id: 11,
    text: "حَسْبِـيَ اللّهُ لا إلهَ إلّا هُوَ عَلَـيهِ تَوَكَّـلتُ وَهُوَ رَبُّ العَرْشِ العَظـيم.",
    repeat: 7,
    benefit: "قال النبي ﷺ: «من قال حين يصبح وحين يمسي سبع مرات: حسبي الله لا إله إلا هو عليه توكلت وهو رب العرش العظيم، كفاه الله ما أهمه».",
    name: "التوكل على الله"
  },
  {
    id: 12,
    text: "بِسـمِ اللهِ الذي لا يَضُـرُّ مَعَ اسمِـهِ شَيءٌ في الأرْضِ وَلا في السّمـاءِ وَهـوَ السّمـيعُ العَلـيم.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قال بسم الله الذي لا يضر مع اسمه شيء ثلاث مرات لم تصبه فجأة بلاء».",
    name: "الحفظ باسم الله"
  },
  {
    id: 13,
    text: "اللّهُـمَّ بِكَ أَصْـبَحْنا وَبِكَ أَمْسَـينا ، وَبِكَ نَحْـيا وَبِكَ نَمُـوتُ وَإِلَـيْكَ النُّـشُور.",
    repeat: 1,
    benefit: "تفويض الأمر كله لله في المساء والصباح.",
    name: "التفويض إلى الله"
  },
  {
    id: 14,
    text: "أَمْسَيْنَا عَلَى فِطْرَةِ الإسْلاَمِ، وَعَلَى كَلِمَةِ الإِخْلاَصِ، وَعَلَى دِينِ نَبِيِّنَا مُحَمَّدٍ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ، وَعَلَى مِلَّةِ أَبِينَا إبْرَاهِيمَ حَنِيفاً مُسْلِماً وَمَا كَانَ مِنَ المُشْرِكِينَ.",
    repeat: 1,
    benefit: "التجديد للإيمان والثبات على الإسلام في كل مساء.",
    name: "الاستقامة على الفطرة"
  },
  {
    id: 15,
    text: "سُبْحـانَ اللهِ وَبِحَمْـدِهِ عَدَدَ خَلْـقِه ، وَرِضـا نَفْسِـه ، وَزِنَـةَ عَـرْشِـه ، وَمِـدادَ كَلِمـاتِـه.",
    repeat: 3,
    benefit: "هذا الذكر يوازن ما قيل من الأذكار طوال اليوم إذا قيل ثلاث مرات.",
    name: "التسبيح الجامع"
  },
  {
    id: 16,
    text: "اللّهُـمَّ عافِـني في بَدَنـي ، اللّهُـمَّ عافِـني في سَمْـعي ، اللّهُـمَّ عافِـني في بَصَـري ، لا إلهَ إلاّ أَنْـتَ.",
    repeat: 3,
    benefit: "دعاء بالعافية في الجسد والسمع والبصر في المساء.",
    name: "طلب العافية"
  },
  {
    id: 17,
    text: "اللّهُـمَّ إِنّـي أَعـوذُ بِكَ مِنَ الْكُـفر ، وَالفَـقْر ، وَأَعـوذُ بِكَ مِنْ عَذابِ القَـبْر ، لا إلهَ إلّا أَنْـتَ.",
    repeat: 3,
    benefit: "الاستعاذة من الكفر والفقر وعذاب القبر.",
    name: "الاستعاذة من الكفر والفقر"
  },
  {
    id: 18,
    text: "اللّهُـمَّ إِنِّي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في الدُّنْـيا وَالآخِـرَة ، اللّهُـمَّ إِنِّي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في ديني وَدُنْـيايَ وَأهْـلي وَمالـي ، اللّهُـمَّ اسْتُـرْ عـوْراتي وَآمِـنْ رَوْعاتـي ، اللّهُـمَّ احْفَظْـني مِن بَـينِ يَدَيَّ وَمِن خَلْفـي وَعَن يَمـيني وَعَن شِمـالي ، وَمِن فَوْقـي ، وَأَعـوذُ بِعَظَمَـتِكَ أَن أُغْـتالَ مِن تَحْتـي.",
    repeat: 1,
    benefit: "كان النبي ﷺ لا يدع هؤلاء الكلمات حين يصبح وحين يمسي.",
    name: "طلب العفو والعافية"
  },
  {
    id: 19,
    text: "يا حَـيُّ يا قَيّـومُ بِـرَحْمَـتِكَ أَسْتَـغـيث ، أَصْلِـحْ لي شَـأْنـي كُلَّـه ، وَلا تَكِلـني إِلى نَفْـسي طَـرْفَةَ عَـين.",
    repeat: 3,
    benefit: "أوصى بها النبي ﷺ فاطمة رضي الله عنها أن تقولها إذا أصبحت وإذا أمست.",
    name: "الاستغاثة بالحي القيوم"
  },
  {
    id: 20,
    text: "أَمْسَيْنا وَأَمْسَى الْمُلْكُ للهِ رَبِّ الْعَالَمَيْنِ، اللَّهُمَّ إِنَّي أسْأَلُكَ خَيْرَ هَذَه اللَّيْلَةِ فَتْحُهَا وَنُصَرُّهَا، وَنورَهُا و برَكَتَهُا، وَهُداهُا، وَأَعُوذُ بِكَ مِنْ شَرِّ مَا فيهِا وَشَرِّ ما بَعْدَهَا.",
    repeat: 1,
    benefit: "افتتاح الليلة بالإقرار بملك الله وسؤاله خير الليل وهدايته والتعوذ من شرها.",
    name: "افتتاح الليلة"
  },
  {
    id: 21,
    text: "اللّهُـمَّ عالِـمَ الغَـيْبِ وَالشّـهادَةِ فاطِـرَ السّماواتِ وَالأرْضِ رَبَّ كـلِّ شَـيءٍ وَمَليـكَه ، أَشْهَـدُ أَنْ لا إِلـهَ إِلاّ أَنْت ، أَعـوذُ بِكَ مِن شَـرِّ نَفْسـي وَمِن شَـرِّ الشَّيْـطانِ وَشِـرْكِه ، وَأَنْ أَقْتَـرِفَ عَلـى نَفْسـي سوءاً أَوْ أَجُـرَّهُ إِلـى مُسْـلِم.",
    repeat: 1,
    benefit: "قال النبي ﷺ لأبي بكر الصديق رضي الله عنه أن يقول هذا إذا أصبح وإذا أمسى.",
    name: "الاستعاذة من شر النفس"
  },
  {
    id: 22,
    text: "أَعـوذُ بِكَلِمـاتِ اللّهِ التّـامّـاتِ مِنْ شَـرِّ ما خَلَـق.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قال حين يمسي: أعوذ بكلمات الله التامات من شر ما خلق، لم تضره حُمَة تلك الليلة».",
    name: "الاستعاذة بكلمات الله"
  },
  {
    id: 23,
    text: "اللَّهُمَّ صَلِّ وَسَلِّمْ وَبَارِكْ على نَبِيِّنَا مُحمَّد.",
    repeat: 10,
    benefit: "قال النبي ﷺ: «من صلى عليَّ حين يصبح عشراً وحين يمسي عشراً أدركته شفاعتي يوم القيامة».",
    name: "الصلاة على النبي ﷺ"
  },
  {
    id: 24,
    text: "اللَّهُمَّ إِنَّا نَعُوذُ بِكَ مِنْ أَنْ نُشْرِكَ بِكَ شَيْئاً نَعْلَمُهُ ، وَنَسْتَغْفِرُكَ لِمَا لَا نَعْلَمُهُ.",
    repeat: 3,
    benefit: "من قاله ذهب عنه كل ما عمل من شرك.",
    name: "الاستعاذة من الشرك"
  },
  {
    id: 25,
    text: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ الْهَمِّ وَالْحَزَنِ، وَأَعُوذُ بِكَ مِنْ الْعَجْزِ وَالْكَسَلِ، وَأَعُوذُ بِكَ مِنْ الْجُبْنِ وَالْبُخْلِ، وَأَعُوذُ بِكَ مِنْ غَلَبَةِ الدَّيْنِ، وَقَهْرِ الرِّجَالِ.",
    repeat: 3,
    benefit: "دعاء جامع للاستعاذة من آفات النفس.",
    name: "الاستعاذة من آفات النفس"
  },
  {
    id: 26,
    text: "أسْتَغْفِرُ اللهَ العَظِيمَ الَّذِي لاَ إلَهَ إلاَّ هُوَ، الحَيُّ القَيُّومُ، وَأتُوبُ إلَيهِ.",
    repeat: 3,
    benefit: "قال النبي ﷺ: «من قال أستغفر الله العظيم وأتوب إليه غُفر له وإن كان فرَّ من الزحف».",
    name: "الاستغفار"
  },
  {
    id: 27,
    text: "يَا رَبِّ , لَكَ الْحَمْدُ كَمَا يَنْبَغِي لِجَلَالِ وَجْهِكَ , وعظيم سُلْطَانِكَ.",
    repeat: 3,
    benefit: "ذكر جامع للحمد يُقرّ فيه العبد بعظمة الله وجلاله وسلطانه.",
    name: "حمد الله على عظيم سلطانه"
  },
  {
    id: 28,
    text: "لا إله إلّا الله وَحْدَهُ لا شَريْكَ لهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءِ قَدِيرِ.",
    repeat: 10,
    benefit: "قال النبي ﷺ: «من قال هذا عشر مرات كانت له عدل عشر رقاب، وكُتب له مئة حسنة، ومُحيت عنه مئة سيئة».",
    name: "التهليل"
  },
  {
    id: 29,
    text: "اللَّهُمَّ أَنْتَ رَبِّي لا إِلَهَ إِلا أَنْتَ ، عَلَيْكَ تَوَكَّلْتُ ، وَأَنْتَ رَبُّ الْعَرْشِ الْكَرِيمِ , مَا شَاءَ اللَّهُ كَانَ ، وَمَا لَمْ يَشَأْ لَمْ يَكُنْ ، وَلا حَوْلَ وَلا قُوَّةَ إِلا بِاللَّهِ الْعَلِيِّ الْعَظِيمِ , أَعْلَمُ أَنَّ اللَّهَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ ، وَأَنَّ الله قَدْ أَحَاطَ بِكُلِّ شَيْءٍ عِلْمًا , اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ شَرِّ نَفْسِي ، وَمِنْ شَرِّ كُلِّ دَابَّةٍ أَنْتَ آخِذٌ بِنَاصِيَتِهَا ، إِنَّ رَبِّي عَلَى صِرَاطٍ مُسْتَقِيمٍ.",
    repeat: 1,
    benefit: "ذكر جامع يتضمن التوكل على الله والإقرار بأن ما شاء الله كان.",
    name: "التوكل الجامع"
  },
  {
    id: 30,
    text: "سبحان الله وبحمده",
    repeat: 100,
    benefit: "قال رسول الله ﷺ: «من قال حين يصبح وحين يمسي: سبحان الله وبحمده مائة مرة، لم يأت أحدٌ يوم القيامة بأفضل مما جاء به».",
    name: "التسبيح"
  },
];

export const tasbeehOptions = [
    'سبحان الله',
    'الحمد لله',
    'الله أكبر',
    'أستغفر الله',
    'سبحان الله وبحمده',
    'سبحان الله العظيم',
    'أستغفر الله العظيم الذي لا إله إلا هو الحي القيوم وأتوب إليه',
    'اللهم صلِ على سيدنا محمد وعلى آله وصحبه وسلم',
    'اللهم صلِ على سيدنا محمد',
    'لا إله إلا الله',
    'لاحول ولاقوة إلا بالله',
    'حسبنا الله ونعم الوكيل'
  ];
